import React, { useState } from 'react';
import './StatusChangePopup.css';

function StatusChangePopup({ contact, onClose, onStatusChange }) {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [loading, setLoading] = useState(false);

  // Debug logging
  console.log('StatusChangePopup opened for contact:', contact);

  const statusOptions = [
    {
      value: 'customer',
      label: 'Customer Only',
      description: 'They bought products but are not interested in the marketing opportunity',
      icon: '🛒',
      color: '#10b981'
    },
    {
      value: 'marketer',
      label: 'Marketer',
      description: 'They registered as a marketer and can recruit others (includes all customer benefits)',
      icon: '🚀',
      color: '#f59e0b'
    },
    {
      value: 'lead',
      label: 'Not Interested',
      description: 'They attended the presentation but decided not to move forward',
      icon: '👥',
      color: '#3b82f6'
    }
  ];

  const handleConfirm = async () => {
    console.log('Confirm clicked, selected status:', selectedStatus);
    
    if (!selectedStatus) {
      alert('Please select an option');
      return;
    }

    setLoading(true);
    try {
      console.log('Making API call to update status...');
      const response = await fetch('/backend/api/contacts/update-status.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          contact_id: contact.id,
          new_status: selectedStatus
        })
      });

      console.log('API Response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('API Response data:', data);
      
      if (data.success) {
        onStatusChange(contact.id, selectedStatus);
        onClose();
      } else {
        alert('Error updating status: ' + data.error);
      }
    } catch (error) {
      console.error('Error updating contact status:', error);
      alert('Failed to update contact status: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="status-change-overlay" onClick={onClose}>
      <div className="status-change-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>What happened after the presentation?</h2>
          <p>How did {contact.first_name} {contact.last_name} respond to the opportunity?</p>
        </div>

        <div className="status-options">
          {statusOptions.map((option) => (
            <div 
              key={option.value}
              className={`status-option ${selectedStatus === option.value ? 'selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedStatus(option.value);
                console.log('Selected status:', option.value);
              }}
              style={{ '--option-color': option.color }}
            >
              <div className="option-header">
                <div className="option-icon" style={{ backgroundColor: option.color }}>
                  {option.icon}
                </div>
                <div className="option-content">
                  <div className="option-label">{option.label}</div>
                  <div className="option-description">{option.description}</div>
                </div>
                <div className="option-radio">
                  <input 
                    type="radio" 
                    name="status" 
                    value={option.value}
                    checked={selectedStatus === option.value}
                    onChange={(e) => {
                      e.stopPropagation();
                      setSelectedStatus(option.value);
                      console.log('Radio selected status:', option.value);
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="modal-actions">
          <button 
            className="cancel-btn"
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            className="confirm-btn"
            onClick={handleConfirm}
            disabled={loading || !selectedStatus}
          >
            {loading ? 'Updating...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default StatusChangePopup;
